const KATS_LINK = "http://10.166.67.27:5022/revision/13";
export default KATS_LINK;